/**
 * Fleet SSE stream management.
 *
 * Opens a persistent SSE connection to the fleet stream endpoint,
 * updating the running count badge on status change events.
 */

import { openFleetStream, fetchFleetDashboard } from './api/fleet.js'

let _fleetStream: EventSource | null = null
let _runningCount = 0

export function startFleetSSE(): void {
  stopFleetSSE()
  _fleetStream = openFleetStream(
    (event) => {
      if (event.type === 'run_started') {
        _runningCount++
      } else if (event.type === 'run_completed' || event.type === 'run_failed') {
        _runningCount = Math.max(0, _runningCount - 1)
      }
      updateRunningBadge(_runningCount)
    },
    () => {
      void refreshRunningCount()
    },
  )
}

export function stopFleetSSE(): void {
  _fleetStream?.close()
  _fleetStream = null
}

export async function refreshRunningCount(): Promise<void> {
  try {
    const dashboard = await fetchFleetDashboard()
    const raw = dashboard?.summary?.running
    // Guard against NaN, Infinity, negatives, and non-numbers from the backend
    const count = typeof raw === 'number' && Number.isFinite(raw) && raw >= 0 ? Math.floor(raw) : 0
    _runningCount = count
    updateRunningBadge(_runningCount)
  } catch {
    // ignore — badge will re-sync on next SSE reconnect
  }
}

function updateRunningBadge(count: number): void {
  const badge = document.getElementById('running-count')
  if (badge) {
    badge.textContent = String(count)
  }
  const prefix = count > 0 ? `(${count}) ` : ''
  const raw = document.title.replace(/^\(\d+\)\s*/, '')
  document.title = prefix + raw
}
